import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'configuraciones/contactos-de-acreedor';

/**
 * GET Contactos Acreedores
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getContactosAcreedores = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Contacto Acreedor
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getContactoAcreedor = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Contacto Acreedor
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postContactoAcreedor = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return false;
};

/**
 * PATCH Contacto Acreedor
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchContactoAcreedor = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return false;
};

/**
 * DELETE Contacto Acreedor
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteContactoAcreedor = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
  }
  return false;
};
